import { render } from "./QaList.vue?vue&type=template&id=749037be&ts=true"
import script from "./QaList.vue?vue&type=script&lang=ts"
export * from "./QaList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__